import { createMarkup } from '@/helper/create-markup'

import { Avatar, AvatarFallback, AvatarImage } from '../avatar'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../dialog'
import { ScrollArea } from '../scroll-area'

interface TestimonialsModalProps {
  personName: string
  profilePhoto: string
  testimonial: string
  description: string
  isModalOpen: boolean
  setIsModalOpen: (open: boolean) => void
}

export function TestimonialsModal({
  description,
  isModalOpen,
  personName,
  profilePhoto,
  testimonial,
  setIsModalOpen,
}: TestimonialsModalProps) {
  return (
    <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
      <DialogContent className="h-auto max-w-3xl gap-6">
        <DialogDescription className="sr-only">
          Detalhes do depoimento de {personName}
        </DialogDescription>
        <DialogHeader className="flex flex-row items-center gap-4">
          <Avatar className="size-16 select-none">
            <AvatarImage
              src={profilePhoto}
              alt="testimonial's avatar"
              className="size-full object-cover"
            />
            <AvatarFallback
              delayMs={300}
              className="bg-bios-300/50 size-16 text-lg font-bold select-none"
            >
              {personName[0]?.toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <div className="text-bios-title flex flex-col text-start">
            <DialogTitle className="text-bios-title text-left">
              {personName}
            </DialogTitle>
            <p className="text-bios-title">{description}</p>
          </div>
        </DialogHeader>
        <ScrollArea className="pr-4">
          <div
            className="max-h-[60vh] break-all whitespace-pre-wrap"
            dangerouslySetInnerHTML={createMarkup(testimonial || '')}
          />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
